/** API enums for F&B restaurant flows */

export const FnBRestaurantSourceType = {
	MANUAL: "MANUAL",
	SEVENROOMS: "SEVENROOMS",
} as const;

export type FnBRestaurantSourceType =
	(typeof FnBRestaurantSourceType)[keyof typeof FnBRestaurantSourceType];

export const FnBVenueStatus = {
	DRAFT: "DRAFT",
	PUBLISHED: "PUBLISHED",
	INACTIVE: "INACTIVE",
} as const;

export type FnBVenueStatus =
	(typeof FnBVenueStatus)[keyof typeof FnBVenueStatus];

export const FnBMenuType = {
	WEB_LINK: "WEB_LINK",
	PDF: "PDF",
} as const;

export type FnBMenuType = (typeof FnBMenuType)[keyof typeof FnBMenuType];

/** GET /fnb-restaurants `sortBy` query enum */
export const FnBRestaurantSortBy = {
	DEFAULT: "DEFAULT",
	NAME: "NAME",
	PROPERTY_NAME: "PROPERTY_NAME",
	SOURCE: "SOURCE",
	STATUS: "STATUS",
	UPDATED_AT: "UPDATED_AT",
} as const;

export type FnBRestaurantSortBy =
	(typeof FnBRestaurantSortBy)[keyof typeof FnBRestaurantSortBy];

export interface FnBRestaurantFaqPayload {
	question: string;
	answer: string;
}

export interface FnBRestaurantUpsertPayload {
	name: string;
	propertyId: string;
	phoneNo?: string;
	status: FnBVenueStatus;
	address?: string;
	googleLocation?: string;
	description?: string;
	bannerImage?: string;
	media?: string[];
	cuisineTags?: string[];
	faqs?: FnBRestaurantFaqPayload[];
	menuType: FnBMenuType;
	menuWebUrl?: string;
	menuPdfUrl?: string;
}
